import { render, staticRenderFns } from "./mainBanner.vue?vue&type=template&id=596b3a9b&scoped=true&"
import script from "./mainBanner.vue?vue&type=script&lang=js&"
export * from "./mainBanner.vue?vue&type=script&lang=js&"
import style0 from "./mainBanner.vue?vue&type=style&index=0&id=596b3a9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b3a9b",
  null
  
)

export default component.exports